import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BoardCard, BoardConfig } from '@app/models/board-card';
import { ApiCrudService } from './api-crud.service';
import { map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BaseConfigService } from './config/base.service';
import { MatDialog } from '@angular/material/dialog';
import { IconsSelectorDialogComponent } from '@app/components/_common/icons-selector-dialog/icons-selector-dialog.component';
import { PlatformService } from './platform.service';

type BoardType = 'user' | 'home' | 'assmat' | 'enseignant';

@Injectable({ providedIn: 'root' })
export class BoardConfigService extends ApiCrudService<BoardConfig> {

  url = 'conf/board';

  private cache = {};

  constructor(
    protected http: HttpClient,
    public baseConfigService: BaseConfigService,
    private dialog: MatDialog,
    public platformService: PlatformService
  ) {
    super();
  }

  set(type: BoardType, config) {
    return super.update({ config }, type);
  }

  getComponent(type: BoardType, componentName: string) {
    return this.get(type).pipe(
      map(conf => conf.cards.find(card => card.component === componentName))
    );
  }

  hasComponent(type: BoardType, componentName: string): Observable<boolean> {
    return this.get(type).pipe(
      map(conf => conf.cards.some(card => (card.component === componentName) && card.enabled))
    );
  }

  get(type: BoardType) {
    return this.cache[type] ? of(this.cache[type]) : super.get(type).pipe(tap(c => this.cache[type] = c));
  }

  onChangeBorderRadius(card: BoardCard) {
    card.contentStyle['borderRadius'] = card.titleStyle['borderRadius'];
  }

  openDialogIcons(data: BoardCard) {
    const ref = this.dialog.open(IconsSelectorDialogComponent, {
      data: { data },
      maxWidth: '700px',
      minWidth: '700px',
    });

    this.platformService.adaptDialogToScreen(ref);
    return ref.afterClosed();
  }

  // Recherche la carte dans toutes les cartes, y compris celles dans les catégories
  findCardByComponentName(cards: BoardCard[], componentName: string): BoardCard | undefined {
    for (const card of cards) {
      if (card.component === componentName) return card;

      if (card.type === 'category' && card.cards) {
        const found = this.findCardByComponentName(card.cards, componentName);
        if (found) return found;
      }
    }
    return undefined;
  }

}
